import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { statisticReviewer } from '@/api/statistic'
import { settingCountry } from '@/api/setting'
import help from '@/utils/help'
import journal from '@/api/journal'

const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'record',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Country / Territory',
    width: 180,
    dataIndex: 'countryCode',
    slot: 'country'
  },
  {
    title: '',
    enTitle: 'Keywords',
    width: 220,
    dataIndex: 'keyword',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Journal',
    width: 150,
    dataIndex: 'journalNameList',
    slot: 'journalNameList'
  },
  {
    title: '',
    enTitle: 'H-index',
    width: 100,
    dataIndex: 'hindex',
    sort: true
  },
  {
    title: '',
    enTitle: 'Invitation',
    width: 100,
    dataIndex: 'invitedNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Invitation Time',
    width: 200,
    dataIndex: 'invitedTime',
    slot: 'invitedTime'
  },
  {
    title: '',
    enTitle: 'Agree',
    width: 100,
    dataIndex: 'agreedNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Declined',
    width: 100,
    dataIndex: 'declinedNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Completed',
    width: 120,
    dataIndex: 'completedNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'No Response',
    width: 140,
    dataIndex: 'noResponseNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Cancelled',
    width: 120,
    dataIndex: 'canceledNum',
    sort: true
  }
]
export default {
  components: {
    SiteSearchGroup
  },
  data() {
    return {
      params: {
        ipublishmentData: false
      },
      journalList: [],
      countryList: [],
      columns: columns,
      dataSource: [],
      staticTime: '',
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser',
      journalId: 'getJournalId'
    })
  },
  mounted() {
    this.countrySearch()
    this.getList()
    this.getJournalList()
  },
  methods: {
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const {
        list,
        pageIndex,
        pageSize,
        total,
        updateTime
      } = await statisticReviewer.get(data)
      this.dataSource = list
      this.staticTime = updateTime

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    async exp() {
      this.loading = true
      try {
        const res = await statisticReviewer.exportData(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    },
    handleClear() {
      this.params.countryCode = ''
      this.params.keyword = ''
      this.params.journalId = ''
      this.getList()
    },
    // 获取杂志列表
    async getJournalList() {
      this.journalList = await journal.getAll({ released: true })
    }
  }
}
